/**
 * Alternativas ao formulário, com o mesmo peso dele: quem não quer
 * preencher campo tem e-mail e LinkedIn à mão. Nada de prender o contato
 * atrás do formulário.
 */
export function ContactAlternatives() {
  return (
    <ul className="grid gap-x-12 gap-y-5 sm:grid-cols-2">
      <Item
        href="mailto:joao@jgson.net"
        titulo="E-mail"
        detalhe="joao@jgson.net"
      />
      <Item
        href="https://www.linkedin.com/in/jgvidotto/"
        titulo="LinkedIn"
        detalhe="/in/jgvidotto"
        externo
      />
    </ul>
  );
}

function Item({
  href,
  titulo,
  detalhe,
  externo,
}: {
  href: string;
  titulo: string;
  detalhe: string;
  externo?: boolean;
}) {
  return (
    <li className="border-t border-jg-border pt-4">
      <span className="block text-sm font-medium">{titulo}</span>
      <a
        className="jg-link mt-1 inline-block text-sm"
        href={href}
        target={externo ? "_blank" : undefined}
        rel={externo ? "noopener noreferrer" : undefined}
      >
        {detalhe}
        {externo && <span aria-hidden="true"> ↗</span>}
      </a>
    </li>
  );
}
